export enum ForumTypeEnum {
  FELLOWSHIP = 1,
  PRAYER = 2,
  TESTIMONY = 3,
  ALL = 4
}
